function DiscussDivider() {
  return (
    <div className="px-6 py-4">
      <div className="w-full h-[1px] bg-gray15" />
    </div>
  );
}

export default DiscussDivider;
